<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>内容管理</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-select v-model="searchData.type" clearable placeholder="请选择类型">
                            <el-option :label="value" :value="key" v-for="(value, key) in typeData" :key="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.tags" clearable placeholder="请选择标签">
                            <el-option :label="item" :value="item" v-for="item in tags" :key="item + '-tags'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.status" clearable placeholder="请选择状态">
                            <el-option label="已发布" :value="2"></el-option>
                            <el-option label="未发布" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.lang" placeholder="请选择语言">
                            <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button button2 add" @click="$router.push({name: 'community-manage'})" v-if="roleCheck('103-103-104-102')">
                            <span>新建</span>
                        </div>
                        <div class="button export" @click="$router.push({name: 'community-tag'})" v-if="roleCheck('103-103-104-102')">
                            <span>标签管理</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table highlight-current-row :data="listData">
                <el-table-column label="ID" prop="id" width="80px"></el-table-column>
                <el-table-column label="类型" prop="type">
                    <template slot-scope="scope">
                        <span>{{ typeData[scope.row.type] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="标签" prop="tags"></el-table-column>
                <el-table-column label="标题" prop="title"></el-table-column>
                <el-table-column label="排序" prop="sort_order" width="60px"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span class="state state2" v-if="scope.row.status == 2">已发布</span>
                        <span class="state state1" v-else-if="scope.row.status == 1">未发布</span>
                    </template>
                </el-table-column>
                <el-table-column label="修改时间" width="160px">
                    <template slot-scope="scope">
                        <span>{{ formDate(scope.row.update_time || scope.row.create_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="button text" v-if="roleCheck('103-103-104-102') && scope.row.status == 1" @click="updateCommunity(scope.row.id, 'publish')">发布</div>
                        <div class="button text" v-if="roleCheck('103-103-104-102') && scope.row.status != 1" @click="updateCommunity(scope.row, 'unpublish')">下架</div>
                        <div class="button text" v-if="roleCheck('103-103-104-102')" @click="$router.push({name: 'community-manage', query: {id: scope.row.id}})" >编辑</div>
                        <div class="button text del_btn" v-if="roleCheck('103-103-104-102')" @click="updateCommunity(scope.row.id, 'delete')">删除</div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Tip ref="tip" :title="tipTitle" :msg="tipContent">
                <template v-slot:confirm_btn>
                    <div class="button del" @click="tipConfirm">
                        <span>确认</span>
                    </div>
                </template>
            </Tip>
        </div>
    </div>
</template>
<script>
export default({
    name: 'community-list',
    data() {
        return {
            typeData: {
                banner: '活动',
                article: '文章',
                multi_image: '图文',
                video: '视频',
            },
            tags: [],
            searchData: {
                page: 1,
                page_size: 20,
                lang: 'zh',
            },
            listData: [],
            total: 0,
            tipContent: '',
            tipTitle: '',
            tipUpdateData: {
                id: '',
                action: ''
            },
            unpublishData: {}
        }
    },
    watch: {
    },
    created() {
        this.getTags();
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        getTags() {
            this.api.getCommunityTags({}).then(data => {
                this.tags = data.data.split(',');
            })
        },
        getList() {
            this.api.getCommunityList(this.searchData).then(data => {
                this.listData = data.data.list || [];
                this.total = data.data.total || 0;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        updateCommunity(id, type) {
            if(type != 'unpublish'){
                this.tipUpdateData = {
                    id: id,
                    action: type
                };
                this.tipTitle = `${type == 'publish' ? '发布' : '删除'}内容`
                this.tipContent = `是否${type == 'publish' ? '发布' : '删除'}内容(id: ${id})？`;
            }else{
                this.tipUpdateData.action = type;
                this.unpublishData = {...id};
                this.unpublishData.status = 1;
                this.tipTitle = '下架内容';
                this.tipContent = `是否下架内容(id: ${id.id})`;
            }
            
            this.$refs.tip.show = true;
        },
        tipConfirm() {
            if(this.tipUpdateData.action != 'unpublish') {
                this.api.communityStatusUpdate(this.tipUpdateData).then(data => {
                    if(data.code == 200) {
                        this.getList();
                        this.$refs.tip.show = false;
                    }
                })
            }else{
                this.api.communityUpdate(this.unpublishData).then(data => {
                    if(data.code == 0 || data.code == 200) {
                        this.getList();
                        this.$refs.tip.show = false;
                    }
                })
            }
            
        }
    }
})
</script>
<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/view/app/community/list.vue